<template>
  <div>
    <el-dialog
        title="可匹配订单列表"
        :lock-scroll="true"
        :visible.sync="dialogFormVisible"
        width="950px"
        :close-on-click-modal="false"
    >
      <section class="dialogContent">
        <TableBox ref="tableBox" :isRadio="true" @closeModal="dialogFormVisible=false" />
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sub" :loading="subLoading">确认并合并订单</el-button>
      </section>
    </el-dialog>
  </div>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBox from './tableBox';
import {mergeOrders } from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBox,
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false,
      originData: {},
      radioResult: {}, // 选择的订单
    };
  },
  methods: {
    show (item) {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.tableBox.saveSearchBoxData({orderId: String(item.orderId)});
        this.originData = item;
        this.$refs.tableBox.formModel = this.originData;

      });
    },
    async sub () {
      this.subLoading = true;
      this.radioResult = this.$refs.tableBox.getSelectRadioData(); // 单选
      if (!this.radioResult) {
        this.$message.warning('请先选择需要匹配的订单');
        this.subLoading = false;
      } else {
        const res = await mergeOrders({
          sourceOrderId: this.originData.orderId,
          sourceVehicleId: this.originData.vehicleId,
          sourcePlateNumber: this.originData.plateNumber,
          matchOrderId: this.radioResult.orderId,
          matchOrderSource: this.radioResult.orderSource,
        });
        this.subLoading = false;
        if (!res.failed) {
          this.dialogFormVisible = false; // 关闭弹窗
          this.$message({
            type: 'success',
            message: '订单匹配成功',
          });
          this.$emit('sub');
        }

      }
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent {
  padding-bottom: 24px;
}
.searchBox {
  ::v-deep .customForm {
    margin: 0;
  }
}
::v-deep .el-radio-group {
  width: 100%;
}
</style>
